// Everything interpolated into an innerHTML template goes through esc(): today's values are safe
// (single chars, normalize()d hex colours, curated font ids/families), and a Google family name will
// arrive in issue params in M2b. Static S.* labels carry no data and stay as they are.
export const esc = (s) => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
